import actionTypes from '../constants/action-types';

const locale = (state = 'en', action) => {
  if (action.type === actionTypes.SET_LOCALE) {
    return action.payload.locale;
  }

  return state;
};

export default locale;
